import Vue from 'vue';
import moment from "moment";

Vue.filter('dateformat', function (value,format) {
    if (!value) return ''

    return moment.unix(value).format(format);
})

Vue.filter('wan', function (value) {
    const num = parseInt(value)
    if (num >= 100000000) {
      return Math.round(num / 100000000 * 100) / 100 + '亿'
    }
    const num2 = num / 10000
    if (num2 >= 1) {
        return Math.round(num2 * 100) / 100 + '万'
    } else {
        return num>0?num:'-'
    }
})



// WEBPACK FOOTER //
// ./src/Filter.js